import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  WMS_GET_CROSSBELT_INBOUND_RATE,
  WMS_GET_CROSSBELT_SCANNER_RATE,
  WMS_GET_CROSSBELT_STATISTIC_INDUCTION,
  WMS_GET_CROSSBELT_STATISTIC_INDUCTION_TOTAL,
  WMS_GET_CROSSBELT_STATISTIC_SORTING,
  WMS_GET_CROSSBELT_STATISTIC_SORTING_TOTAL,
  WMS_GET_SORTING_DEVICES,
  WMS_GET_PROVINCES,
  WMS_GET_WHEEL_SORTING_RATE,
  WMS_GET_WHEEL_STATISTIC_INDUCTION,
  WMS_GET_WHEEL_STATISTIC_SORTING,
  WMS_GET_WHEEL_STATISTIC_SORTING_TOTAL,
  WMS_GET_WHEEL_STATISTIC_INDUCTION_TOTAL,
  WMS_GET_STATIONS,
  WMS_GET_USERS,
} from "./constants";
import services from "services";
import { size } from "lodash";


const fetchUsers = createAsyncThunk(WMS_GET_USERS, async (params) => {
  const response = await services.WmsService.getUsers(params);
  return response;
});

const fetchSortingDevices = createAsyncThunk(
  WMS_GET_SORTING_DEVICES,
  async () => {
    const response = await services.WmsService.getSortingDevices();
    return response;
  }
);
const fetchProvinces = createAsyncThunk(WMS_GET_PROVINCES, async () => {
  const response = await services.WmsService.getWmsProvince();
  return response;
});
const fetchStations = createAsyncThunk(WMS_GET_STATIONS, async (params) => {
  const response = await services.WmsService.getStationsData(params);
  return response;
});
const fetchCrossbeltInboundRate = createAsyncThunk(
  WMS_GET_CROSSBELT_INBOUND_RATE,
  async ({ type, stationId }) => {
    const response = await services.WmsService.getCrossbeltInboundRate(
      type,
      stationId
    );
    return response;
  }
);
const fetchCrossbeltScannerRate = createAsyncThunk(
  WMS_GET_CROSSBELT_SCANNER_RATE,
  async ({ type, stationId }) => {
    const response = await services.WmsService.getCrossbeltScannerRate(
      type,
      stationId
    );
    return response;
  }
);

const fetchCrossbeltStatisticInduction = createAsyncThunk(
  WMS_GET_CROSSBELT_STATISTIC_INDUCTION,
  async ({ type, stationId }) => {
    const response = await services.WmsService.getCrossbeltStatisticsInduction(
      type,
      stationId
    );
    return response;
  }
);

const fetchCrossbeltStatisticSorting = createAsyncThunk(
  WMS_GET_CROSSBELT_STATISTIC_SORTING,
  async ({ type, stationId }) => {
    const response = await services.WmsService.getCrossbeltStatisticsSorting(
      type,
      stationId
    );
    return response;
  }
);

const fetchCrossbeltStatisticSortingTotal = createAsyncThunk(
  WMS_GET_CROSSBELT_STATISTIC_SORTING_TOTAL,
  async (stationId) => {
    let response = await Promise.all([
      services.WmsService.getCrossbeltStatisticsSorting("today", stationId),
      services.WmsService.getCrossbeltStatisticsSorting("yesterday", stationId),
      services.WmsService.getCrossbeltStatisticsSorting("lastweek", stationId),
    ]);
    if (!response || size(response) !== 3)
      return { today: {}, yesterday: {}, lastWeek: {} };
    return {
      today: response[0],
      yesterday: response[1],
      lastWeek: response[2],
    };
  }
);
const fetchCrossbeltStatisticInductionTotal = createAsyncThunk(
  WMS_GET_CROSSBELT_STATISTIC_INDUCTION_TOTAL,
  async (stationId) => {
    let response = await Promise.all([
      services.WmsService.getCrossbeltStatisticsInduction("today", stationId),
      services.WmsService.getCrossbeltStatisticsInduction(
        "yesterday",
        stationId
      ),
      services.WmsService.getCrossbeltStatisticsInduction(
        "lastweek",
        stationId
      ),
    ]);
    if (!response || size(response) !== 3)
      return { today: {}, yesterday: {}, lastWeek: {} };
    return {
      today: response[0],
      yesterday: response[1],
      lastWeek: response[2],
    };
  }
);

const fetchWheelSortingRate = createAsyncThunk(
  WMS_GET_WHEEL_SORTING_RATE,
  async ({ type, deviceSortingId }) => {
    const response = await services.WmsService.getWheelSortingRate(
      type,
      deviceSortingId
    );
    return response;
  }
);

const fetchWheelStatisticInduction = createAsyncThunk(
  WMS_GET_WHEEL_STATISTIC_INDUCTION,
  async ({ type, deviceSortingId }) => {
    const response = await services.WmsService.getWheelStatisticsInduction(
      type,
      deviceSortingId
    );
    return response;
  }
);

const fetchWheelStatisticSorting = createAsyncThunk(
  WMS_GET_WHEEL_STATISTIC_SORTING,
  async ({ type, deviceSortingId }) => {
    const response = await services.WmsService.getWheelStatisticsSorting(
      type,
      deviceSortingId
    );
    return response;
  }
);

const fetchWheelStatisticSortingTotal = createAsyncThunk(
  WMS_GET_WHEEL_STATISTIC_SORTING_TOTAL,
  async (deviceSortingId) => {
    let response = await Promise.all([
      services.WmsService.getWheelStatisticsSorting("today", deviceSortingId),
      services.WmsService.getWheelStatisticsSorting(
        "yesterday",
        deviceSortingId
      ),
      services.WmsService.getWheelStatisticsSorting(
        "lastweek",
        deviceSortingId
      ),
    ]);
    if (!response || size(response) !== 3)
      return { today: {}, yesterday: {}, lastWeek: {} };
    return {
      today: response[0],
      yesterday: response[1],
      lastWeek: response[2],
    };
  }
);
const fetchWheelStatisticInductionTotal = createAsyncThunk(
  WMS_GET_WHEEL_STATISTIC_INDUCTION_TOTAL,
  async (deviceSortingId) => {
    let response = await Promise.all([
      services.WmsService.getWheelStatisticsInduction("today", deviceSortingId),
      services.WmsService.getWheelStatisticsInduction(
        "yesterday",
        deviceSortingId
      ),
      services.WmsService.getWheelStatisticsInduction(
        "lastweek",
        deviceSortingId
      ),
    ]);
    if (!response || size(response) !== 3)
      return { today: {}, yesterday: {}, lastWeek: {} };
    return {
      today: response[0],
      yesterday: response[1],
      lastWeek: response[2],
    };
  }
);

const wmsThunks = {
  fetchUsers,
  fetchSortingDevices,
  fetchStations,
  fetchProvinces,
  fetchCrossbeltInboundRate,
  fetchCrossbeltScannerRate,
  fetchCrossbeltStatisticInduction,
  fetchCrossbeltStatisticSorting,
  fetchCrossbeltStatisticSortingTotal,
  fetchCrossbeltStatisticInductionTotal,
  fetchWheelSortingRate,
  fetchWheelStatisticInduction,
  fetchWheelStatisticSorting,
  fetchWheelStatisticSortingTotal,
  fetchWheelStatisticInductionTotal,
};
export default wmsThunks;
